<template>
  <div class="map-bg" @mousemove.stop="getMousePos($event)" @click="insetPos($event)">
    <slot name="label" />
    <span v-show="showAxis && (mapInnerPos.x || mapInnerPos.y)" class="map-position-warp">X: {{ mapInnerPos.x }} Y: {{ mapInnerPos.y }}</span>
  </div>
</template>

<script>
export default {
  name: 'MapBg',
  props: {
    showAxis: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      mapInnerPos: {
        x: 0,
        y: 0
      }
    }
  },
  methods: {
    getMousePos(event) {
      this.mapInnerPos.x = event.offsetX || event.layerX
      this.mapInnerPos.y = event.offsetY || event.layerY
    },
    insetPos(event) {
      this.$emit('inset', {
        x: event.offsetX || event.layerX,
        y: event.offsetY || event.layerY
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .map-bg{
    width: 920px;
    height: 850px;
    background: url("../images/map-bg.png") no-repeat center;
    background-size: 755px 676px;
    position: relative;
    .map-position-warp{
      position: absolute;
      bottom: 6px;
      left: 8px;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.6);
    }
    .agency-label{
      position: absolute;
      top: 0;
      left: 0;
      transform: translate(-50%, -50%);
    }
  }
</style>
